import type { AthenaPostgresPool } from "../../../postgres/driver.ts";
import type { AthenaClientInternals } from "../../../runtime/client-internals.ts";
import { createBillingSqlExecutor } from "../../import/postgres.ts";
import {
	type BillingWebhookIngressObservability,
	createLazyBillingWebhookIngressObservability,
} from "./health.ts";

function isAthenaPostgresPool(value: unknown): value is AthenaPostgresPool {
	return (
		value != null &&
		typeof value === "object" &&
		typeof (value as AthenaPostgresPool).query === "function" &&
		typeof (value as AthenaPostgresPool).connect === "function"
	);
}

export function billingWebhookIngressObservabilityFromInternals(
	internals: AthenaClientInternals | undefined,
): BillingWebhookIngressObservability {
	return createLazyBillingWebhookIngressObservability(async () => {
		const owned = internals?.postgresRuntime;
		const pool = owned ? await owned.getPool() : undefined;
		if (!isAthenaPostgresPool(pool)) {
			return undefined;
		}
		return createBillingSqlExecutor(pool);
	});
}
